//#region src/tools/surfaces.ts
/**
* Central policy for direct MCP exposure.
*
* Tool modules define behavior: name, description, schema, annotations, and
* handler. Ordinary tools are catalog-eligible by default. This file only lists
* wrapper/infrastructure tools outside the catalog and the explicit subset also
* exposed through tools/list.
*/
const CATALOG_INFRASTRUCTURE_TOOL_NAMES = ["search_sentry_tools", "execute_sentry_tool"];
const WRAPPER_TOOL_NAMES = [];
const TOP_LEVEL_TOOL_NAMES = [
	"find_organizations",
	"find_projects",
	"update_issue",
	"search_events",
	"analyze_issue_with_seer",
	"search_issues",
	"get_sentry_resource",
	...CATALOG_INFRASTRUCTURE_TOOL_NAMES
];
const EXPERIMENTAL_TOP_LEVEL_TOOL_NAMES = TOP_LEVEL_TOOL_NAMES;
const topLevelToolNames = new Set(TOP_LEVEL_TOOL_NAMES);
const wrapperToolNames = new Set(WRAPPER_TOOL_NAMES);
const catalogInfrastructureToolNames = new Set(CATALOG_INFRASTRUCTURE_TOOL_NAMES);
function isOutsideCatalogToolName(toolName) {
	return wrapperToolNames.has(toolName) || catalogInfrastructureToolNames.has(toolName);
}
function isDefaultTopLevelToolName(toolName) {
	return topLevelToolNames.has(toolName);
}
function isTopLevelToolName(toolName, _experimentalMode) {
	return topLevelToolNames.has(toolName);
}
function getTopLevelToolNames({ experimentalMode: _experimentalMode }) {
	return TOP_LEVEL_TOOL_NAMES;
}
function isWrapperToolName(toolName) {
	return wrapperToolNames.has(toolName);
}
function isCatalogInfrastructureToolName(toolName) {
	return catalogInfrastructureToolNames.has(toolName);
}

//#endregion
export { CATALOG_INFRASTRUCTURE_TOOL_NAMES, EXPERIMENTAL_TOP_LEVEL_TOOL_NAMES, TOP_LEVEL_TOOL_NAMES, WRAPPER_TOOL_NAMES, getTopLevelToolNames, isCatalogInfrastructureToolName, isDefaultTopLevelToolName, isOutsideCatalogToolName, isTopLevelToolName, isWrapperToolName };
//# sourceMappingURL=surfaces-B1_F0pzt.js.map